import { useState } from "react";
import CustomSnackbar from "../../../../../../components/ui/CustomSnackbar/customSnackbar";
import parentStyles from "../../../Details/details.module.css";
import { Button } from '@mui/material';
import styles from './UpdatePlanModal.module.css'
import CustomModal from "../../../../../../components/ui/CustomModal/customModal";
import ApiService from "../../../../../../components/apiService/ApiService";

const UpdatePlanModal = (props) => {
    const {setVisible, visible, curPlan, plans, currentPlanCurrency, accountId} = props;
    const [plan, setPlan] = useState(curPlan);
    const [response, setResponse] = useState({});
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [customerId, setCustomerId] = useState("");
    const [startDate, setStartDate] = useState("");

    const handleFeedback = (response) => {
      console.log(response);
      if (response?.success) {
        setResponse(response);
      } else {
        setResponse({
          message: response.message,
          success: false,
        });
      }
      setShowSnackbar(true);
    };

    const handleSaveChanges = () => {
        let payload = {
            plan: plan,
        }
        if(customerId) {
            payload["zoho_customer_id"] = customerId
        }
        if(startDate) {
            payload["start_date"] = startDate
        }
        ApiService.patch(
        `/api/v1/dashboard/update-subscription/${accountId}/`,
        payload,
        )
        .then((res) => {
            setShowSnackbar(true);
            setResponse({
            message: "Subscription will be updated shortly",
            success: true,
            });
        })
        .catch((error) => {
            handleFeedback(error.response);
        })
        .finally(() => {
            setVisible(false);
        })

  };


    return (
      <>
        <CustomModal
            heading="Update Plan"
            visible={visible}
            closeModal={() => setVisible(false)}
            bodyStyles={{
              width: "380px",
              padding: "2em",
            }}
            body={
              <div>
                <div className={styles.container}>
                  <form className={styles.form}>
                    <div className={parentStyles.property}>
                      <label>Plan</label>
                      <select
                        value={plan || ''}
                        onChange={(e) => {
                          setPlan(e.target.value)
                        }}
                      >
                      <option value="" disabled hidden>None</option>
                      {
                        plans.filter(plan => !plan?.toLowerCase()?.includes('trial'))
                        .map(plan => <option value={plan}>{plan}</option>)
                      }
                      </select>
                    </div>
                    {!plan?.includes(currentPlanCurrency) && 
                        <div className={parentStyles.property}>
                            <label style={{marginBottom: '5px'}}>Enter zoho customer id if the customer already exists in Zoho Billing target org, else leave blank</label>
                            <input
                                placeholder="Enter zoho customer id"
                                type="text"
                                value={customerId}
                                onChange={(e) => setCustomerId(e.target.value)}
                            />
                        </div>
                    }
                    {!plan?.includes(currentPlanCurrency) && (
                     <div className={parentStyles.property}>
                        <label>Start date</label>
                        <div className={parentStyles.clm}>
                            <input
                            type="date"
                            name="subs_start_date"
                            value={startDate}
                            onChange={(e) => {
                                setStartDate(e.target.value);
                            }}
                            />
                        </div>
                    </div>
                )}
                </form>
                <div className={styles.footerContainer}>
                   <Button
                        sx={{
                          margin: "35px 5px 0",
                        }}
                        className={parentStyles.button}
                        variant="outlined"
                        color="success"
                        onClick={() => setVisible(false)}
                      >
                        Cancel
                      </Button>
                    <Button
                        sx={{
                          margin: "35px 5px 0",
                          bgcolor: "#36cb64",
                          color: "white",
                          ":hover": {
                            bgcolor: "#28994B",
                          },
                        }}
                        className={parentStyles.button}
                        variant="outlined"
                        onClick={handleSaveChanges}
                        disabled={plan === curPlan || !curPlan}
                      >
                        Update
                      </Button>
                </div>
               </div>
              </div>
            }
        />
        {showSnackbar && (
          <CustomSnackbar
            setShowSnackbar={setShowSnackbar}
            message={response.message}
            type={response.success ? "success" : "error"}
            onClose={() => setShowSnackbar(false)}
          />
        )}
    </>)
}

export default UpdatePlanModal